import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavController} from '@ionic/angular';
import { AppDetectorProvider } from '../../../providers/detector/detector';
import { SessionProvider } from '../../../providers/session/session';
import { UserProvider } from '../../../providers/user/user';
import { Router } from '@angular/router';


/**
 * Generated class for the WelcomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-welcome-restyle',
    templateUrl: 'welcome-restyle.html',
    styleUrls:['./welcome-restyle.scss']
})
export class WelcomeRestylePage {

    constructor(
        private appDetector: AppDetectorProvider,
        public userService: UserProvider,
        public navCtrl: NavController,
        public router:Router,
        public translate: TranslateService,
        private sessionService: SessionProvider,
        private detectorProvider: AppDetectorProvider
    ) {
        console.log("welcome")
    }

    ionViewDidEnter() {
    }

    skip() {
        // let page = this.appDetector.isEventsApp() ? EventSearchPage : TabsPage;
        let page = this.appDetector.isEventsApp() ? '/ event-search' : '/tabs';
        // this.navCtrl.setRoot(page);
        this.navCtrl.navigateForward(page);
    }

    public isLoged(): boolean {
        return this.sessionService.isLoged;
    }

    showLogin() {
        if (this.detectorProvider.isHellaApp()) {
            this.sessionService.getToken(false, false).then(token => {
                // this.app.getRootNav().push(IdRegistrationPage);
                this.navCtrl.navigateForward('/auth/id-registration');
            });
        } else {
            // this.app.getRootNav().push(LoginPage)
            this.navCtrl.navigateForward('/auth/login');
        }
    }

}
